// Admin tenant switcher state (Q-B10). The selected override rides on API
// calls as X-Reframer-Tenant; handlers honor it only for members of the
// Cognito `admin` group, so a stale value in a non-admin's storage is
// harmless (the API falls back to 403 on mismatch attempts).

const STORAGE_KEY = 'edl-tools.tenantOverride';
type Listener = (tenant: string | null) => void;

let override: string | null = null;
try {
  override = window.localStorage.getItem(STORAGE_KEY);
} catch {
  // storage unavailable (private mode etc.) — run without persistence
}

const listeners = new Set<Listener>();

export function getTenantOverride(): string | null {
  return override;
}

export function setTenantOverride(tenant: string | null): void {
  override = tenant;
  try {
    if (tenant) window.localStorage.setItem(STORAGE_KEY, tenant);
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // best-effort persistence only
  }
  listeners.forEach((fn) => fn(tenant));
}

export function subscribeTenantOverride(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
